/** @module SiteAdmin/Locale/_TableMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/core/Key",
	"csi/state/rootStore",
	"../Locale",

	"csi/view/ToolbarFind"
], function(declare, lang, Key, {localStore, sessionStore}, Locale) {

	return declare(null, {
		disableCustomViewToolbar: true,
		findAttributes: ["Id", "Resources", "SourceType", "TypeName"],
		queryLimit: 0,

		// Function: class to use to create store
		storeClass: null,

		onBuildDeferreds: function(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: ensure that localization resources are loaded for the locale selected for edit
			dfds.push(Locale.loadEditResolvers());
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: allow aggregation of any Classifier
			var ql = this.inherited(arguments);
			if (ql.bMain) {
				ql.createCustomStore = lang.hitch(this, this._createStore);
			}

			return ql;
		},

		_createStore: function(/*Context*/ctx, /*Boolean*/bConfigurable) {
			// summary: create store for view
			return new this.storeClass({
				cachingStore: this.cacheView,
				configLocale: localStore.editLocale,
			});
		},

		/**
		 * @override
		 * Hide Site display name if edit locale is set to the site locale
		 */
		onViewResolveKeysToSkip(skipSet) {
			if (sessionStore.siteLocale == localStore.editLocale) {
				skipSet.add(Key.untypedKeyFromParts({
					index: "Site",
					name: "LocaleSite",
				}));
			}
		},
	});
});